module.exports = __webpack_public_path__ + "static/img/topNav.1f01aa49.png";